import React, { useState, useRef, useEffect } from "react";
import {
  FaEye,
  FaEdit,
  FaTrash,
  FaChevronUp,
  FaChevronDown,
  FaFire,
  FaFireAlt,
  FaTag,
  FaIdBadge,
  FaCalendarAlt,
} from "react-icons/fa";
import { FaBoxOpen, FaFire as FaFire6 } from "react-icons/fa6";
import { useMediaQuery } from "react-responsive";
import { MdFiberNew, MdOutlineFiberNew } from "react-icons/md";

function _ProductRow({
  product,
  checked,
  foreign = {},
  onCheck,
  setActivePanel,
  setEditIndex,
  editIndex,
  setReloadList,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);
  const [height, setHeight] = useState("0px");
  const isMobile = useMediaQuery({ maxWidth: 600 });

  const animeSeries = foreign.animeSeries || [];
  const manufacturers = foreign.manufacturers || [];
  const category = foreign.categories || [];
  const sanitizeFolderName = (name) => {
    return name.replace(/[^a-z0-9_\- ]/gi, "_");
  };
  const formatToMMDDYYYY = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  };
  useEffect(() => {
    if (contentRef.current) {
      setHeight(isOpen ? "260px" : "0px");
    }
  }, [isOpen]);

  const handleDelete = () => {
    if (window.confirm("Are you sure you want to delete this product?")) {
      fetch(
        `${process.env.REACT_APP_BASE_URL}api/product/delete-product/${product.PD_ID}`,
        {
          method: "DELETE",
          credentials: "include",
        },
      )
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            alert("Product deleted successfully.");
            setReloadList(true); // Trigger list reload
          } else {
            alert("Failed to delete product.");
          }
        })
        .catch((err) => {
          console.error("Error deleting product:", err);
          alert("An error occurred while deleting the product.");
        });
    }
  };
  {
    /** 
  const toggleProductFlag = (field, newValue) => {
    const payload = { [field]: newValue ? 1 : 0 };

     fetch(`${process.env.REACT_APP_BASE_URL}api/product/update-flags/${product.PD_ID}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setReloadList(true); // Refresh table
        } else {
          alert("Failed to update product flag.");
        }
      })
      .catch((err) => {
        console.error("Error updating flag:", err);
        alert("Error updating product flag.");
      });
  };*/
  }
  const toggleFlag = async (flag) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/product/toggle-flag/${product.PD_ID}`,
        {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ flag }),
        },
      );

      const data = await res.json();
      if (data.success) {
        //alert(data.message);
        setReloadList(true);
      } else {
        alert(data.message); // e.g. "Only 5 products can be marked as Most Pop"
      }
    } catch (err) {
      console.error("Toggle flag failed:", err);
      alert("Failed to update flag.");
    }
  };
  if (!isMobile) {
    return (
      <>
        {/* Main Row */}
        <tr>
          <td
            className="td-toggle-icon"
            onClick={() => {
              isOpen ? setIsOpen(false) : setIsOpen(true);
            }}
          >
            {isOpen ? (
              <FaChevronUp className="toggle-icon" title="Collapse" />
            ) : (
              <FaChevronDown className="toggle-icon" title="Expand" />
            )}
          </td>
          {/** 
        <td className="td-toggle-icon2">
          <input type="checkbox" checked={checked} onChange={onCheck} />
        </td>*/}
          <td>
            <img
              src={`${process.env.REACT_APP_BASE_URL}Assets/Products/${product.PD_ID}/${product.PD_ProductPicPath[0]}`}
              alt={product.PD_Name}
              width="50"
            />
          </td>
          <td>{product.PD_Name}</td>
          <td>{product.PD_OriginalPrice}</td>
          <td>
            {product.PD_ProductType === "onhand" ? "ON HAND" : "PREORDER"}
          </td>
          <td>{product.PD_SaleCount}</td>
          <td>
            <div className="td-action-btns-wrapper">
              {/* Most Popular */}
              <FaFire6
                className={`action-icon mostPop ${
                  product.PD_IsMostPop ? "active" : ""
                }`}
                title="Most Popular"
                onClick={() => toggleFlag("PD_IsMostPop")}
              />

              {/* New Arrival */}
              <MdFiberNew
                className={`action-icon new ${
                  product.PD_IsNewArrival ? "active" : ""
                }`}
                title="New Arrival"
                onClick={() => toggleFlag("PD_IsNewArrival")}
              />

              {/* Show Onhand only if product type is not preorder */}
              {product.PD_ProductType !== "preorder" && (
                <FaBoxOpen
                  className={`action-icon onhand ${
                    product.PD_IsOnhand ? "active" : ""
                  }`}
                  title="Onhand"
                  onClick={() => toggleFlag("PD_IsOnhand")}
                />
              )}

              {/* Show Preorder only if product type is not onhand */}
              {product.PD_ProductType !== "onhand" && (
                <FaCalendarAlt
                  className={`action-icon preorder ${
                    product.PD_IsPreOrder ? "active" : ""
                  }`}
                  title="Pre-Order"
                  onClick={() => toggleFlag("PD_IsPreOrder")}
                />
              )}
            </div>
          </td>
          <td>
            <div className="td-action-btns-wrapper">
              {/** <FaEye className="action-icon view" title="View" />*/}
              <FaEdit
                className="action-icon edit"
                title="Edit"
                onClick={() => {
                  setActivePanel(2);
                  setEditIndex(product.PD_ID);
                }}
              />
              <FaTrash
                className="action-icon delete"
                title="Delete"
                onClick={handleDelete}
              />
            </div>
          </td>
        </tr>

        {/* Collapsible Row */}
        <tr>
          <td
            className="td-other-product-field"
            colSpan={8}
            style={{ padding: 0, border: 0 }}
          >
            <div
              ref={contentRef}
              style={{
                maxHeight: height,
                overflow: "hidden",
                transition: "max-height 0.4s ease, opacity 0.3s ease",
                opacity: isOpen ? 1 : 0,
              }}
              className="other-collapse-content"
            >
              <div style={{ padding: "10px" }}>
                {product.PD_ProductType === "onhand" ? (
                  <>
                    <p>
                      <strong>Number of Stock:</strong> {product.PD_Stock}
                    </p>
                    <p>
                      <strong>Sales Price:</strong> {product.PD_SalePrice}
                    </p>
                  </>
                ) : (
                  <>
                    <p>
                      <strong>Preorder Deadline:</strong>{" "}
                      {formatToMMDDYYYY(product.PD_Preorderdeadline)}
                    </p>
                    <p>
                      <strong>Japan Estimated Release:</strong>{" "}
                      {product.PD_JapanEstmated}
                    </p>
                  </>
                )}
                <p>
                  <strong>Downpayment:</strong> {product.PD_DownPayment}
                </p>
              </div>

              <div>
                <p>
                  <strong>Category:</strong>{" "}
                  {category.find((cat) => cat.PC_ID === product.PC_ID)
                    ?.PC_Name || "N/A"}
                </p>
                <p>
                  <strong>Anime Series:</strong>{" "}
                  {animeSeries.find((anime) => anime.AS_ID === product.AS_ID)
                    ?.AS_Name || "N/A"}
                </p>
                <p>
                  <strong>Manufacturer:</strong>{" "}
                  {manufacturers.find((manu) => manu.PM_ID === product.PM_ID)
                    ?.PM_Name || "N/A"}
                </p>
              </div>
            </div>
          </td>
        </tr>
      </>
    );
  } else {
    return (
      <>
        {/* Main Row */}
        <tr>
          <td
            className="td-toggle-icon"
            onClick={() => {
              isOpen ? setIsOpen(false) : setIsOpen(true);
            }}
          >
            {isOpen ? (
              <FaChevronUp className="toggle-icon" title="Collapse" />
            ) : (
              <FaChevronDown className="toggle-icon" title="Expand" />
            )}
          </td>
          {/** 
        <td className="td-toggle-icon2">
          <input type="checkbox" checked={checked} onChange={onCheck} />
        </td>*/}
          <td>
            <img
              src={`${process.env.REACT_APP_BASE_URL}Assets/Products/${product.PD_ID}/${product.PD_ProductPicPath[0]}`}
              alt={product.PD_Name}
              width="50"
            />
          </td>
          <td>{product.PD_Name}</td>
          <td>
            {product.PD_ProductType === "onhand" ? "ON HAND" : "PREORDER"}
          </td>
          <td>
            <div className="td-action-btns-wrapper">
              {/* Most Popular */}
              <FaFire6
                className={`action-icon mostPop ${
                  product.PD_IsMostPop ? "active" : ""
                }`}
                title="Most Popular"
                onClick={() => toggleFlag("PD_IsMostPop")}
              />

              {/* New Arrival */}
              <MdFiberNew
                className={`action-icon new ${
                  product.PD_IsNewArrival ? "active" : ""
                }`}
                title="New Arrival"
                onClick={() => toggleFlag("PD_IsNewArrival")}
              />

              {/* Show Onhand only if product type is not preorder */}
              {product.PD_ProductType !== "preorder" && (
                <FaBoxOpen
                  className={`action-icon onhand ${
                    product.PD_IsOnhand ? "active" : ""
                  }`}
                  title="Onhand"
                  onClick={() => toggleFlag("PD_IsOnhand")}
                />
              )}

              {/* Show Preorder only if product type is not onhand */}
              {product.PD_ProductType !== "onhand" && (
                <FaCalendarAlt
                  className={`action-icon preorder ${
                    product.PD_IsPreOrder ? "active" : ""
                  }`}
                  title="Pre-Order"
                  onClick={() => toggleFlag("PD_IsPreOrder")}
                />
              )}
            </div>
          </td>
        </tr>

        {/* Collapsible Row */}
        <tr>
          <td
            className="td-other-product-field"
            colSpan={8}
            style={{ padding: isOpen ? "10px" : 0, border: 0 }}
          >
            <div
              ref={contentRef}
              style={{
                maxHeight: height,
                overflow: "hidden",
                transition: "max-height 0.4s ease, opacity 0.3s ease",
                opacity: isOpen ? 1 : 0,
              }}
              className="other-collapse-content"
            >
              <div>
                {product.PD_ProductType === "onhand" ? (
                  <>
                    <p>
                      <strong>Original Price:</strong>
                      {product.PD_OriginalPrice}
                    </p>
                    <p>
                      <strong>Sales Price:</strong> {product.PD_SalePrice}
                    </p>
                    <p>
                      <strong>Sale Count:</strong>
                      {product.PD_SaleCount}
                    </p>
                  </>
                ) : (
                  <>
                    <p>
                      <strong>Preorder Deadline:</strong>{" "}
                      {formatToMMDDYYYY(product.PD_Preorderdeadline)}
                    </p>
                    <p>
                      <strong>Japan Estimated Release:</strong>{" "}
                      {product.PD_JapanEstmated}
                    </p>
                  </>
                )}
                <p>
                  <strong>Downpayment:</strong> {product.PD_DownPayment}
                </p>
              </div>

              <div>
                <p>
                  <strong>Number of Stock:</strong> {product.PD_Stock}
                </p>
                <p>
                  <strong>Category:</strong>{" "}
                  {category.find((cat) => cat.PC_ID === product.PC_ID)
                    ?.PC_Name || "N/A"}
                </p>
                <p>
                  <strong>Anime Series:</strong>{" "}
                  {animeSeries.find((anime) => anime.AS_ID === product.AS_ID)
                    ?.AS_Name || "N/A"}
                </p>
                <p>
                  <strong>Manufacturer:</strong>{" "}
                  {manufacturers.find((manu) => manu.PM_ID === product.PM_ID)
                    ?.PM_Name || "N/A"}
                </p>{" "}
                <div className="td-action-btns-wrapper">
                  {/** <FaEye className="action-icon view" title="View" />*/}
                  <FaEdit
                    className="action-icon edit"
                    title="Edit"
                    onClick={() => {
                      setActivePanel(2);
                      setEditIndex(product.PD_ID);
                    }}
                  />
                  <FaTrash
                    className="action-icon delete"
                    title="Delete"
                    onClick={handleDelete}
                  />
                </div>
              </div>
            </div>
          </td>
        </tr>
      </>
    );
  }
}

export default _ProductRow;
